module.exports = __webpack_public_path__ + "static/img/s204.9de59ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s204.png
// module id = 546
// module chunks = 3